import { solicitacaoService } from '../../../services';

/** Aceita tanto o link inteiro (copiado pelo botão "Copiar link" de outra Solicitação)
 * quanto só o ID colado direto — sem precisar de um campo de busca (identificar a
 * solicitação certa por nome/tipo fica ambíguo quando a mesma pessoa tem várias). */
export function extrairIdDoLinkOuTexto(valor: string): string {
  const bruto = valor.trim();
  const match = bruto.match(/\/si\/solicitacoes\/([^/?#]+)/);
  return match ? match[1] : bruto;
}

/**
 * Valida o campo "Solicitação relacionada" (Cancelar/Excluir) antes de confirmar — sem
 * isso, um link colado errado (ou uma Solicitação que não existe) só falhava depois, com
 * um toast que passa despercebido e não deixa claro qual dos 3 problemas aconteceu.
 */
const LINK_INVALIDO =
  'Esse link não é válido. Copie o link pelo ícone de copiar (🔗) na outra Solicitação, ou cole só o ID diretamente.';

export async function resolverSolicitacaoRelacionada(
  valorBruto: string,
  idAtual: string
): Promise<{ id: string } | { erro: string }> {
  const bruto = valorBruto.trim();
  const pareceLink = /^https?:\/\//i.test(bruto);
  const id = extrairIdDoLinkOuTexto(bruto);

  if (pareceLink && id === bruto) {
    return { erro: LINK_INVALIDO };
  }
  // ID de documento do Firestore nunca contém '/' — se sobrou uma barra aqui, ou o link
  // colado não bateu o padrão esperado, ou o texto não é um ID válido. Sem essa checagem,
  // `doc()` lança uma exceção síncrona ao montar a referência (mais segmentos que o
  // esperado) que travava a verificação pra sempre (nunca chegava no try/catch do caller).
  if (id === '' || id.includes('/')) {
    return { erro: LINK_INVALIDO };
  }
  if (id === idAtual) {
    return { erro: 'Não dá pra vincular a Solicitação a ela mesma.' };
  }

  try {
    const encontrada = await solicitacaoService.getById(id);
    if (!encontrada) {
      return { erro: 'Não encontrei nenhuma Solicitação com esse link/ID — confira e tente de novo.' };
    }
    return { id };
  } catch {
    return { erro: 'Não consegui verificar essa Solicitação agora — confira o link/ID e tente de novo.' };
  }
}
